import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sponsor" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "wallets" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = ["title"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "copy-text" }
const _hoisted_8 = {
  key: 0,
  class: "note"
}
const _hoisted_9 = { class: "muted" }

import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import wallets from '@/services/sponsor'


export default /*@__PURE__*/_defineComponent({
  __name: 'SponsorUs',
  setup(__props) {

const { t } = useI18n()

const copied = ref<Record<string, boolean>>({})

async function copy(addr: string, key: string) {
  try {
    await navigator.clipboard.writeText(addr)
    copied.value = { ...copied.value, [key]: true }
    setTimeout(() => {
      copied.value = { ...copied.value, [key]: false }
    }, 1500)
  } catch (e) {
    // no-op
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: "intro",
      innerHTML: _unref(t)('sponsor.intro')
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wallets), (w) => {
        return (_openBlock(), _createElementBlock("div", {
          key: w.key,
          class: "wallet"
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(w.label), 1),
          _createElementVNode("code", {
            class: "addr",
            title: w.address
          }, _toDisplayString(w.address), 9, _hoisted_5),
          _createElementVNode("button", {
            type: "button",
            class: "copy",
            onClick: ($event: any) => (copy(w.address, w.key))
          }, [
            _cache[0] || (_cache[0] = _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              width: "18",
              height: "18",
              "aria-hidden": "true"
            }, [
              _createElementVNode("path", {
                fill: "currentColor",
                d: "M16 1H4a2 2 0 0 0-2 2v12h2V3h12V1zm3 4H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm0 16H8V7h11v14z"
              })
            ], -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString(copied.value[w.key] ? _unref(t)('sponsor.copied') : _unref(t)('sponsor.copy')), 1)
          ], 8, _hoisted_6)
        ]))
      }), 128))
    ]),
    (_unref(t)('sponsor.notice'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)('sponsor.notice')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})